import React, { useState } from 'react';
import { notification, Select, Spin } from 'antd';
import debounce from 'lodash/debounce';
import ProcessoService from '../../services/ProcessoService';
import * as Routes from '../../../scripts/routes';

const { Option } = Select;

const SearchEventoProcesso = ({ tipo }) => {
  const [data, setData] = useState([]);
  const [value, setValue] = useState([]);
  const [fetching, setFetching] = useState(false);
  const [initialLoad, setInitialLoad] = useState(false); // Para rastrear a busca inicial

  const fetchOptions = (query = '') => {
    setData([]);
    setFetching(true);

    ProcessoService
      .search_by_evento(query, tipo)
      .then((result) => result.data)
      .then((data) => {
        setData(data);
        setFetching(false);
      })
      .catch(error => {
        setFetching(false);
        notification.info({
          message: 'Erro',
          description: `${error}`,
          duration: 10,
          placement: 'bottomRight'
        });
      });
  };

  const _onSearch = debounce((value) => {
    fetchOptions(value);
  }, 800);

  const _onChange = (value) => {
    setData([]);
    setFetching(false);
    setValue(value);
  };

  const _onSelect = (item) => {
    if (tipo === 'interno' || tipo === 'interessado') {
      Turbolinks.visit(Routes.usuario_processos_path({ evento: item.key, tipo: tipo }));
    } else {
      Turbolinks.visit(Routes.usuario_processos_path({ evento: item.key }));
    }
  };

  const _onFocus = () => {
    if (!initialLoad) {
      fetchOptions(); // Busca inicial sem filtro
      setInitialLoad(true);
    }
  };

  return (
    <Select
      showSearch
      allowClear
      labelInValue
      value={value}
      placeholder='Escolha o evento do processo'
      notFoundContent={fetching ? <Spin size='small' /> : null}
      filterOption={false}
      onChange={_onChange}
      onSearch={_onSearch}
      onSelect={_onSelect}
      onFocus={_onFocus} // Dispara a busca ao focar no campo
      style={{ width: '100%' }}
      size={'large'}
    >
      {data.map(d => (
        <Option key={d.value}>{d.text}</Option>
      ))}
    </Select>
  );
};

export default SearchEventoProcesso;
